import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'
// @ts-ignore
import 'swiper/css'
// @ts-ignore
import 'swiper/css/navigation'
import { useDeviceDetect } from '../../utils/use-device-detect'
import './InfoSection.scss'
import { serverUrl } from '../../request'
import { getStorageKey, getAppType } from '../../utils/appType'

const c = 'info-section'

function fallbackSrc() {
  return getAppType() === 'catering'
    ? '/panda-catering-logo-bamboo.png'
    : '/logo_bg.png'
}

function handleImgError({ currentTarget }: React.SyntheticEvent<HTMLImageElement>) {
  currentTarget.onerror = null
  currentTarget.src = fallbackSrc()
}

const InfoSection = () => {
  const generalInfo = (() => {
    try {
      return JSON.parse(localStorage.getItem(getStorageKey('info')) || '{}')
    } catch {
      return {}
    }
  })()

  const images: string[] = generalInfo?.images || []
  const { isMobile, isTablet } = useDeviceDetect()

  if (images.length === 0) {
    return <div className={c} />
  }

  const renderCard = (image: string, index: number) => (
    <div className={`${c}__card`}>
      <img
        src={serverUrl + image}
        alt={`banner-${index + 1}`}
        onError={handleImgError}
      />
    </div>
  )

  // On mobile: always swiper with 2 per view (single row, never wraps)
  // On tablet/desktop with >4 images: swiper; otherwise grid
  const useSwiper = isMobile || images.length > 4
  const slidesPerView = isMobile ? 2 : isTablet ? 2 : 4

  if (useSwiper) {
    return (
      <div className={c}>
        <Swiper
          modules={[Navigation, Autoplay]}
          className={`${c}__swiper`}
          spaceBetween={12}
          slidesPerView={slidesPerView}
          navigation
          loop={images.length > slidesPerView}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={image}>
              {renderCard(image, index)}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    )
  }

  return (
    <div className={c}>
      <div className={`${c}__grid`} data-count={images.length}>
        {images.map((image, index) => (
          <React.Fragment key={image}>
            {renderCard(image, index)}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default InfoSection
